// ** Icons Import
import { Home, Circle } from "react-feather";

export default [
  {
    id: "onboarding",
    title: "Onboarding",
    icon: <Home size={20} />,
    badge: "light-warning",
    // badgeText: "2",
    children: [
      {
        id: "waitingApprovementIndividual",
        title: "Unverified Accounts",
        icon: <Circle size={12} />,
        navLink: '/onboarding/individual'
      },
      /**{
        id: "waitingApprovementCorporate",
        title: "Corporate",
        icon: <Circle size={12} />,
        navLink: '/onboarding/corporate'
      },**/
      {
        id: "manualOnboard",
        title: "Manual Onboarding",
        icon: <Circle size={12} />,
        navLink: '/onboarding/manual'
      },
    ],
  },
];
